import { EventEmitter } from "eventemitter3";
import { createContext } from "react";

export const KeyboardShortcutsContext = createContext<EventEmitter>(
  new EventEmitter(),
);
